import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import compose from 'recompose/compose'
import withHandlers from 'recompose/withHandlers'

import { usersAndProperties } from './selectors'
import CurrentTeamMembers from './component'
import * as OrgActions from 'app/modules/org/actions'

const mapStateToProps = (state) => ({
  usersAndProperties: usersAndProperties(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      sendExistingUsersInvitationsViaEmail: OrgActions.sendExistingUsersInvitationsViaEmail,
      sendInvitationsViaEmail: OrgActions.sendInvitationsViaEmail,
    },
    dispatch,
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    sendExistingUsersInvitationsViaEmail: props => (userId) => {
      const { actions: { sendExistingUsersInvitationsViaEmail }} = props
      sendExistingUsersInvitationsViaEmail(userId)
    },
    sendInvitationsViaEmail: props => (email) => {
      const { actions: { sendInvitationsViaEmail }} = props
      sendInvitationsViaEmail({ user: { email }, properties: { extensionInvited: true }})
    },
  }),
)(CurrentTeamMembers)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/ExtensionInviteModal/CurrentTeamMembers/index.js